<template>
  <el-dialog :title="title"
             :close-on-click-modal="false"
             width="650px"
             @closed="close"
             :visible.sync="visible">
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             size="medium"
             label-width="140px"
             @submit.native.prevent="onSubmit()">
      <div class="re-el-form__flex">
        <div class="medium">
          <el-form-item label="账户名称"
                        prop="name"
                        clearable>
            <el-input v-model="form.name"
                      placeholder="请输入账户名称" />
          </el-form-item>
          <el-form-item label="银行卡号"
                        prop="number">
            <el-input v-model="form.number"
                      :disabled="!!form.id"
                      placeholder="请输入银行卡号" />
          </el-form-item>
          <el-form-item label="所属公司"
                        prop="our_company_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请选择所属公司"
              v-model="form.our_company_id"
              :query-request="ourCompaniesLists"
              :find-request="getOurCompanyDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="所属开户银行"
                        prop="bank_id">
            <el-select v-model="form.bank_id">
              <el-option
                v-for="item in banks"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="close()"> 取消 </el-button>
        <el-button type="primary"
                   @click="onSubmit()"> 确定
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import { companyAccountFormRules as formRules } from '../../finance-config.rules'

export default {
  data () {
    return {
      visible: false,
      formRules,
      form: {
        id: null,
        our_company_id: null,
        name: '',
        number: '',
        bank_id: '',
      },
      banks: [
        {
          name: null,
          number: null
        }
      ]
    }
  },
  computed: {
    title () {
      return this.form.id ? '修改账户' : '创建账户'
    }
  },
  methods: {
    ...request.map([
      'ourCompaniesLists',
      'getOurCompanyDetail',
    ]),
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.id ? this.update(this.form) : this.create(this.form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create (data) {
      request.common('createOurCompanyAccount', data).then(({data}) => {
        this.$message.success(this.title + '成功')
        this.$emit('submitted')
        this.close()
      })
    },
    update (data) {
      request.common('updateOurCompanyAccount', data).then(({data}) => {
        this.$message.success(this.title + '成功')
        this.$emit('submitted')
        this.close()
      })
    },
    show (id) {
      this.visible = true

      request.common('getBankTable').then(({data}) => {
        this.banks = data.data

        if (id) {
          this.form.id = id
          request.common('getCompanyAccountManagementDetail', {id}).then(({data}) => {
            filter.setLoop(this.form, data)
          })
        }
      })
    },
    close () {
      this.visible = false
      Object.assign(this.$data, this.$options.data.call(this))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/finance-config/pages/company-account-management/CompanyAccountManagementFormDialog.vue